export const slugify = (text) => {
  if (!text) return '';
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')     // Replace spaces with -
    .replace(/[^\w\-]+/g, '') // Remove all non-word chars
    .replace(/\-\-+/g, '-')   // Replace multiple - with single -
    .replace(/^-+/, '')       // Trim - from start of text
    .replace(/-+$/, '');      // Trim - from end of text
};

export const optimizeImage = (url, width = 800) => {
  if (!url) return '';
  if (url.includes('images.unsplash.com')) {
    return `${url.split('?')[0]}?q=90&w=${width}&auto=format&fit=crop`;
  }
  // Netlify Image CDN for mainlandfireplaces assets and local public images
  // Only apply in production so local dev doesn't break
  if (import.meta.env.PROD && (url.includes('assets.mainlandfireplaces.com') || url.startsWith('/images/'))) {
    return `/.netlify/images?url=${encodeURIComponent(url)}&w=${width}&q=80`;
  }
  return url;
};

export const generateSrcSet = (url, widths = [400, 800, 1200, 1600]) => {
  if (!url) return null;
  
  if (url.includes('images.unsplash.com')) {
    const baseUrl = url.split('?')[0];
    return widths.map(w => `${baseUrl}?q=80&w=${w}&auto=format&fit=crop ${w}w`).join(', ');
  }

  // Netlify Image CDN for mainlandfireplaces assets and local public images
  // Only apply in production so local dev doesn't break
  if (import.meta.env.PROD && (url.includes('assets.mainlandfireplaces.com') || url.startsWith('/images/'))) {
    const encodedUrl = encodeURIComponent(url);
    return widths.map(w => `/.netlify/images?url=${encodedUrl}&w=${w}&q=80 ${w}w`).join(', ');
  }

  return null;
};
